/* eslint-disable max-len */
import categoryApi from '../../api/category'

const GET_CATEGORY_LIST = 'GET_CATEGORY_LIST'

const initialState = {
  categories: [],
}

let fetchCategoryPromise = null

export const getCategoryListAction = (forceRefetch = false) => async (dispatch, getState) => {
  const { category } = getState()
  if (!forceRefetch && category?.categories?.length > 0) return
  if (!forceRefetch && fetchCategoryPromise) return fetchCategoryPromise

  fetchCategoryPromise = (async () => {
    try {
      const { msgResp } = await categoryApi.getCategoryList()
      dispatch({
        type: GET_CATEGORY_LIST,
        payload: Array.isArray(msgResp) ? msgResp : [],
      })
    } catch (error) {
      console.error('getCategoryListAction error:', error)
    } finally {
      fetchCategoryPromise = null
    }
  })()

  return fetchCategoryPromise
}

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORY_LIST:
      return {
        ...state,
        categories: action.payload,
      }
    default:
      return state
  }
}

export default categoryReducer
